import React from 'react';
import _ from 'lodash';
import { priceFormatterV3 } from '../../../settings/themeSettings';
import SectionHeader from '../components/SectionHeader';

const TOClientsSection = ({ dashboardData }) => {
    const clients = dashboardData?.clients || [];

    // Trier par CA décroissant
    const topClients = [...clients].sort((a, b) => b.ca - a.ca).slice(0, 10);
    const totalCAClients = _.sumBy(clients, 'ca') || 0;

    return (
        <div className="analysis-section">
            <SectionHeader
                title="👥 ANALYSE TO / CLIENTS"
                pdfData={topClients.map(c => ({
                    metrique: c.nom,
                    montant: c.ca,
                    pourcentage: totalCAClients > 0 ? `${((c.ca / totalCAClients) * 100).toFixed(1)}%` : "0%",
                    marge: c.marge || 0
                }))}
                pdfFilename="analyse-clients-to.pdf"
                pdfTitle="Top 10 Clients / TO"
                pdfTableHeaders={["Client", "CA", "% Marge", "Marge"]}
            />

            <div className="table-container-prof">
                <div className="table-title-prof">TOP 10 CLIENTS / TO PAR CHIFFRE D'AFFAIRES</div>
                <table className="professional-table">
                    <thead>
                        <tr>
                            <th className="text-left">CLIENT / TO</th>
                            <th className="text-right">NB DOSSIERS</th>
                            <th className="text-right">CHIFFRE D'AFFAIRES</th>
                            <th className="text-right">MARGE</th>
                            <th className="text-right">% MARGE</th>
                            <th className="text-right">% DU CA TOTAL</th>
                        </tr>
                    </thead>
                    <tbody>
                        {topClients.map((client, index) => {
                            const percentCA = totalCAClients > 0 ? ((client.ca / totalCAClients) * 100).toFixed(1) : 0;
                            const percentMarge = client.ca > 0 ? ((client.marge / client.ca) * 100).toFixed(1) : 0;

                            return (
                                <tr key={index}>
                                    <td className="text-left"><strong>{client.nom}</strong></td>
                                    <td className="number-cell">{client.nbDossiers || 0}</td>
                                    <td className="currency-cell">{priceFormatterV3(client.ca)}</td>
                                    <td className="currency-cell">{priceFormatterV3(client.marge)}</td>
                                    <td className="percentage-cell">{percentMarge}%</td>
                                    <td className="percentage-cell">{percentCA}%</td>
                                </tr>
                            );
                        })}
                    </tbody>
                    <tfoot>
                        <tr className="total-row-prof">
                            <td className="text-left"><strong>TOTAL TOP 10</strong></td>
                            <td className="number-cell">{_.sumBy(topClients, 'nbDossiers')}</td>
                            <td className="currency-cell">{priceFormatterV3(_.sumBy(topClients, 'ca'))}</td>
                            <td className="currency-cell">{priceFormatterV3(_.sumBy(topClients, 'marge'))}</td>
                            <td className="percentage-cell">
                                {_.sumBy(topClients, 'ca') > 0 ?
                                    ((_.sumBy(topClients, 'marge') / _.sumBy(topClients, 'ca')) * 100).toFixed(1) : 0}%
                            </td>
                            <td className="percentage-cell">
                                {totalCAClients > 0 ?
                                    ((_.sumBy(topClients, 'ca') / totalCAClients) * 100).toFixed(1) : 0}%
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    );
};

export default TOClientsSection;
